export default "__VITE_ASSET__B$qkvrA3__"